import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW7001Model } from '../kymw7001.model';

// レスポンス構造
type CheckFeatureSelectionResponse = {
  NormalPCodeList: { PCode: string }[];
}[];

/**
 * 表紙特集商品選定情報チェックサービス
 * @export CheckFeatureSelectionService
 * @class CheckFeatureSelectionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckFeatureSelectionService extends PlessJsonResponderSub<CheckFeatureSelectionResponse> {
  model: KYMW7001Model;
  private calbak: (model: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CheckFeatureSelectionService
   */
  private successFunc: (model: any) => void;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckFeatureSelectionService
   */
  private getBody(): PlessRequest {

    const checkTargetListInfo = this.model.TargetListInfo
      .filter(_ => _.check)
      .map(item => ({
        parameter: {
          PCode: item.pCode
        }
      }))
    const chkObj = {
      checkFeatureSelection: {
        condition: {
          OrderCode: this.model.orderCode
        },
        combination: checkTargetListInfo
      },
    };
    
    return new PlessRequest({ search: chkObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof CheckFeatureSelectionService
   */
  execute(model: KYMW7001Model, successFunc: (model: any) => void): void {
    this.model = model;
    this.successFunc = successFunc;
    if (successFunc) this.calbak = successFunc;
    this.send('checkFeatureSelection', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckFeatureSelectionService
   */
  success(data: CheckFeatureSelectionResponse) {
    if (data !== null) {
      this.successFunc(data);
    }
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
